import { Node as ShellNode } from './node';
import { nodeSymbol, modalNodesManagerSymbol } from '../symbols';
export var ModalNodesManager = /*#__PURE__*/function () {
  function ModalNodesManager(modalNodesManager) {
    this[modalNodesManagerSymbol] = void 0;
    this[modalNodesManagerSymbol] = modalNodesManager;
  }
  ModalNodesManager.create = function create(modalNodesManager) {
    if (!modalNodesManager) {
      return null;
    }
    return new ModalNodesManager(modalNodesManager);
  }

  /**
   * 设置模态节点，触发内部事件
   */;
  var _proto = ModalNodesManager.prototype;
  _proto.setNodes = function setNodes() {
    this[modalNodesManagerSymbol].setNodes();
  }

  /**
   * 获取模态节点（们）
   */;
  _proto.getModalNodes = function getModalNodes() {
    var innerNodes = this[modalNodesManagerSymbol].getModalNodes();
    var shellNodes = [];
    innerNodes === null || innerNodes === void 0 ? void 0 : innerNodes.forEach(function (node) {
      var shellNode = ShellNode.create(node);
      if (shellNode) {
        shellNodes.push(shellNode);
      }
    });
    return shellNodes;
  }

  /**
   * 获取当前可见的模态节点
   */;
  _proto.getVisibleModalNode = function getVisibleModalNode() {
    return ShellNode.create(this[modalNodesManagerSymbol].getVisibleModalNode());
  }

  /**
   * 隐藏模态节点（们）
   */;
  _proto.hideModalNodes = function hideModalNodes() {
    this[modalNodesManagerSymbol].hideModalNodes();
  }

  /**
   * 设置指定节点为可见态
   * @param node Node
   */;
  _proto.setVisible = function setVisible(node) {
    this[modalNodesManagerSymbol].setVisible(node[nodeSymbol]);
  }

  /**
   * 设置指定节点为不可见态
   * @param node Node
   */;
  _proto.setInvisible = function setInvisible(node) {
    this[modalNodesManagerSymbol].setInvisible(node[nodeSymbol]);
  };
  return ModalNodesManager;
}();